import NextLink from 'next/link'

import { Text } from '@wartek-id/text-v1'

import CardNotificationBase from './CardNotificationBase'
import useBasePath from 'app/KinerjaTimPenilaiPSPage/hooks/useBasePath'

import type { CardNotificationBaseProps } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'

const CardNotificationPenilaianPeriodik = (
  cardProps: CardNotificationBaseProps
) => {
  const { basePath } = useBasePath()

  return (
    <CardNotificationBase {...cardProps}>
      <div className="mt-6">
        <NextLink href={basePath} passHref>
          <Text
            color="informational"
            variant="body-sm"
            className="!font-semibold cursor-pointer"
          >
            Ke Menu Penilaian Periodik
          </Text>
        </NextLink>
      </div>
    </CardNotificationBase>
  )
}

export default CardNotificationPenilaianPeriodik
